import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=4d45d8c9&scoped=true"
import script from "./NotificationsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=4d45d8c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45d8c9",
  null
  
)

export default component.exports